export default __webpack_public_path__ + "static/media/11.3111afc7.jpg";